import type * as React from 'react';
import { Link } from 'react-router-dom';
import { buttonVariants, cn } from '@phinest/ui';

/**
 * Adapter for the design system's `linkComponent` prop, which takes `href`.
 * Passing this keeps client-side navigation working inside shared components.
 */
export function RouterLink({ href, children, ...rest }: { href: string; className?: string; children?: React.ReactNode; 'aria-current'?: 'page' }) {
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}

/**
 * A navigation link that looks like a button. The design system's Button is a
 * real <button>, so anything that navigates uses this instead of nesting them.
 */
export function LinkButton({
  to,
  variant,
  size,
  className,
  children,
}: {
  to: string;
  variant?: Parameters<typeof buttonVariants>[0] extends infer P ? (P extends { variant?: infer V } ? V : never) : never;
  size?: Parameters<typeof buttonVariants>[0] extends infer P ? (P extends { size?: infer S } ? S : never) : never;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Link to={to} className={cn(buttonVariants({ variant, size }), className)}>
      {children}
    </Link>
  );
}
